<div class="d-flex justify-content-between fondo-gris azul-titulos p-5 content general">
    <div>
        <h2 class="ms-5" class="title">{{ modulo }}</h2>
    </div>
    <div *ngIf="mostrar">
        <button class="btn btn-secondary me-5" (click)="regresar()">Inicio</button>
    </div>
</div>
